import { NotificationType } from '@baserow/modules/core/notificationTypes'
import Icon from '@baserow/modules/core/components/Icon'
import AutomationUsageThresholdNotification from '@saas/components/notifications/AutomationUsageThresholdNotification'

export class AutomationUsageThresholdNotificationType extends NotificationType {
  static getType() {
    return 'automation_usage_threshold_reached'
  }

  getIconComponent() {
    return () => (
      <Icon
        class="notification-panel__notification-automation-icon"
        icon="baserow-icon-automation"
        type="secondary"
        size="large"
      />
    )
  }

  getContentComponent() {
    return AutomationUsageThresholdNotification
  }

  getRoute(notificationData) {
    return {
      name: 'subscriptions',
    }
  }
}
